/*-----------------------------------------------------------------
- Fields translations
-----------------------------------------------------------------*/

export default {
    your_name             : 'اسمك',
    your_email            : 'بريدك الالكتروني',
    company_name          : 'اسم الشركة',
    message               : 'رسالة',
    mobile                : 'هاتف',
    your_file             : 'ملفك',
    name                  : 'اسم',
    email                 : 'بريد إلكتروني',
    attachment            : 'تحميل السيرة الذاتية',
    country_selector_label: 'الرقم الدولي',
    country_selector_error: 'اختر الدولة',
    phone_number_label    : 'رقم التليفون',
    example               : 'مثال:',
    message_title         : 'موضوع الرسالة',

};
